// Values map to the PdfJS internal values:
// NONE: 0, SELF: 1, BLANK: 2, PARENT: 3, TOP: 4

enum PdfjsLinkTargets {
  'new-window' = 2,
  'same-window' = 4,
}

export default PdfjsLinkTargets;
